import { CSSProperties } from 'react';
import styles from './index.module.less';
import mobxWrap from '@/components/MobxWrap';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';
import { ProductTracker } from '@/utils/Tracker';

type Props = {
  style?: CSSProperties;
  from: 'stickyBar' | 'productList';
};

/** 导流商品按钮 */
const ProductRedirectButton = mobxWrap<Props, ['product', 'area']>(
  ['product', 'area'],
  ({ product, area, style, from }) => {
    const { LANG, country } = area;
    const { code } = country;
    // 商品id
    const productId = product.productDetail.id;

    // 导流重定向链接
    const redirectData = ThirdPartyPlatformConfig.getRedirectUrl(productId, code);

    // 没有导流链接
    if (!redirectData) return null;

    return (
      <div className={styles.redirect} style={style}>
        <button
          data-from={from}
          className={styles.btn}
          onClick={() => {
            // 数据上报
            ProductTracker.productPage({
              action: 'go_to_bestbuy',
              productState: product.productDetail,
              label: `${productId}_${from}`,
            });

            window.open(redirectData.url, '_blank');
          }}
        >
          {LANG['product.page.goToBestbuy']}
          <div className={styles.icon}>
            <img src='https://res.insta360.com/static/4f9ae5e8f6b6f12e64da6a17b79a1c39/logo-01%202.png' alt='' />
          </div>
        </button>
      </div>
    );
  }
);

export default ProductRedirectButton;
